import { Controller } from "react-hook-form"
import Select from 'react-select';
import makeAnimated from "react-select/animated";
import "./SelectComponent.css"
import styled from "styled-components";
import { Colors } from "../colors/colors";




const SelectComponent = ({
  placeholder,
  name,
  cName,
  id,
  hasLabel,
  label,
  errorText,
  options,
  value,
  control,
  defaultValue,
  multiSelect
}) => {

  const {
    primaryColorLightest,
    dangerColor,
    primaryColor,
  } = Colors();

  const animatedComponents = makeAnimated();





  return (
    <SelectComponentWrapper>
      <div
        className="d-flex flex-column"
      >
        {hasLabel && (<label className="form-label">{label}</label>)}

        <Controller
          rules={{ required: true }}
          name={name}
          control={control}
          defaultValue={defaultValue}
          render={({ field: { onChange, onBlur, ref } }) => (
            <Select
              closeMenuOnSelect={!multiSelect}
              components={animatedComponents}
              isMulti={multiSelect}
              options={options}
              value={value}
              onChange={(val) => onChange(val)}
              onBlur={onBlur}
              ref={ref}
              classNames={{
                control: (state) =>
                  state.isFocused ? 'border-grey' : 'border-grey-300',
              }}
              className={`input ${cName} gap-5`}
              id={id}
              placeholder={placeholder}
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  borderColor: errorText ? dangerColor : state.isFocused ? '#fff' : '#fff',
                  backgroundColor: 'transparent',
                  minWidth: "100%",
                  margin: "0"
                }),
                placeholder: (baseStyles) => {
                  return {
                    ...baseStyles,
                  };
                },
                // Style for the dropdown indicator (arrow)
                indicatorSeparator: (provided) => ({
                  ...provided,
                  margin: "0",
                  height: "90%",
                  backgroundColor: "transparent", // Change this to the desired font color
                }),
                singleValue: (provided) => ({
                  ...provided,
                }),
                option: (base) => ({
                  ...base,
                }),
              }}
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  primary25: primaryColorLightest,
                  primary: primaryColor,
                  danger: dangerColor
                },
              })}
            />
          )}
        />
      </div>

      {errorText && <small
        style={{
          margin: 0,
          color: dangerColor
        }}
      >
        {errorText || ""}
      </small>
      }
    </SelectComponentWrapper>
  );
};

export default SelectComponent;


const SelectComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-bottom: 1rem;
`;